import { createAction, createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { IOrganizationsListState } from './interfaces';
import { deleteRequest, getRequest } from 'api/requests';
import { IOrganization } from 'interfaces/main';
import { createOrganization } from 'features/CreateOrganizationModal/CreateOrganizationModalSlice';

// Замена лота в списке
export const exchangeOrganization = createAction(
	'organizationsList/exchangeOrganization',
	(organization: IOrganization) => ({ payload: organization }),
);

// Загрузка списка организаций
export const fetchOrganizations = createAsyncThunk(
	'organizationsList/fetchOrganizations',
	async (_, { rejectWithValue, getState }) => {
		try {
			console.log('- - - - - - - - - - - - - - - -');
			console.log('organizationsList/fetchOrganizations');
			const { user } = getState() as RootState;

			const response = await getRequest(
				'organization',
				[5].includes(user.roleId) ? {} : { id: user.organizationId },
				true,
			);

			return response.data;
		} catch (error) {
			return rejectWithValue(error);
		}
	},
);

// Удаление организации
export const removeOrganization = createAsyncThunk(
	'organizationsList/removeOrganization',
	async (id: number, { rejectWithValue }) => {
		try {
			const response = await deleteRequest(`organization/${id}`, {}, true);

			return response.data.id;
		} catch (error) {
			return rejectWithValue(error);
		}
	},
);

// Selectors
export const OrganizationsListSelector = (state: RootState): IOrganizationsListState =>
	state.organizationsList;

export const OrganizationsListLoadingSelector = createSelector(
	OrganizationsListSelector,
	({ isLoading }) => isLoading,
);

export const OrganizationsListItemsSelector = createSelector(
	OrganizationsListSelector,
	({ items }) => items,
);

const initialState: IOrganizationsListState = {
	isLoading: false,
	items: [],
};

const organizationsListSlice = createSlice({
	name: 'organizationsList',
	initialState,
	reducers: {
		exchangeOrganization: (state, { payload }) => ({
			...state,
			items: state.items.map((item: IOrganization) => (item.id === payload.id ? payload : item)),
		}),
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchOrganizations.pending, (state) => ({
				...state,
				isLoading: true,
			}))
			.addCase(fetchOrganizations.rejected, (state) => ({
				...state,
				isLoading: false,
			}))
			.addCase(fetchOrganizations.fulfilled, (state, { payload }) => ({
				...state,
				isLoading: false,
				items: payload,
			}))
			.addCase(removeOrganization.pending, (state) => ({
				...state,
				isLoading: true,
			}))
			.addCase(removeOrganization.rejected, (state) => ({
				...state,
				isLoading: false,
			}))
			.addCase(removeOrganization.fulfilled, (state, { payload }) => ({
				...state,
				isLoading: false,
				items: state.items.filter((item: IOrganization) => item.id !== payload),
			}))
			.addCase(createOrganization.fulfilled, (state, { payload }) => ({
				...state,
				isLoading: false,
				items: [...state.items, payload],
			}));
	},
});

export default organizationsListSlice.reducer;
